import type { z } from "zod";
import {
  createTagRequestSchema,
  tagSchema,
  updateTagRequestSchema,
} from "./schemas";

export type Tag = z.infer<typeof tagSchema>;
export type CreateTagRequest = z.infer<typeof createTagRequestSchema>;
export type UpdateTagRequest = z.infer<typeof updateTagRequestSchema>;

export const DEFAULT_TAG_COLOR = "#E5E7EB";
